export const NavShareIcon = ({
  size = 24,
  color = 'white',
  className,
}: {
  size?: number
  color?: string
  className?: string
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_290_13273)">
        <path
          d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5"
          stroke={color}
          strokeLinecap="round"
        />
        <path
          d="M16.5482 7.20137L13.9183 9.39784C12.6998 10.4155 11.9825 11.9116 11.9521 13.4989V13.4989M16.5482 7.20137V10.7369M16.5482 7.20137H13.0127"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_290_13273">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
